import { render, staticRenderFns } from "./LocationSummaryCard.vue?vue&type=template&id=32df8c28&scoped=true&"
import script from "./LocationSummaryCard.vue?vue&type=script&lang=js&"
export * from "./LocationSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./LocationSummaryCard.vue?vue&type=style&index=0&id=32df8c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df8c28",
  null
  
)

export default component.exports